import { render, staticRenderFns } from "./template.vue?vue&type=template&id=3dc03948&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc03948",
  null
  
)

export default component.exports